import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import "core-js/modules/es.array.includes.js";
import { Drawer as MuiDrawer } from "../Drawer";
import styled from '@emotion/styled';
import { GRAY } from "../../constants/colors/hex";
var drawerShouldForwardProps = function drawerShouldForwardProps(key) {
  return (
    // Disable passing these props to the MuiDrawer since it
    // will try to add them to the DOM element as attributes
    // and will result in a console warning.
    !['panelWidth', 'panelMaxWidth'].includes(key)
  );
};
export var Drawer = styled(MuiDrawer, {
  shouldForwardProp: drawerShouldForwardProps
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .MuiPaper-root {\n    width: ", ";\n    max-width: ", ";\n    min-width: 360px;\n    background: ", ";\n  }\n"])), function (_ref) {
  var panelWidth = _ref.panelWidth;
  return panelWidth || 'auto';
}, function (_ref2) {
  var panelMaxWidth = _ref2.panelMaxWidth;
  return panelMaxWidth || 'none';
}, GRAY[21]);